export interface ChainConfig {
  chainId: string
  chainName: string
  namespace: string
  cgwUrl: string
  scanApi?: {
    url: string
    apiKey: string
  }
  blockscoutUrl?: string
  blockscoutV2Url?: string
}

export const CHAINS: {
  [chainId: string]: ChainConfig
} = {
  '2632500': {
    chainId: '2632500',
    chainName: 'coti',
    namespace: 'coti-mainnet',
    cgwUrl: 'https://prod.coti-mainnet-client-gateway.keypersafe.xyz',
  },
  '1514': {
    chainId: '1514',
    chainName: 'story',
    namespace: 'story',
    cgwUrl: 'https://prod.story-client-gateway.keypersafe.xyz',
    blockscoutUrl: 'https://www.storyscan.io',
    blockscoutV2Url: 'https://www.storyscan.io',
  },
  '1315': {
    chainId: '1315',
    chainName: 'story-aeneid-testnet',
    namespace: 'story',
    cgwUrl: 'https://prod.story-client-gateway.keypersafe.xyz',
    blockscoutUrl: 'https://aeneid.storyscan.io',
    blockscoutV2Url: 'https://aeneid.storyscan.io',
  },
  '14': {
    chainId: '14',
    chainName: 'Flare',
    namespace: 'flare',
    cgwUrl: 'https://prod.flare-client-gateway.keypersafe.xyz',
  },
  '999': {
    chainId: '999',
    chainName: 'HyperEVM',
    namespace: 'hyperliquid',
    cgwUrl: 'https://prod.hyperliquid-client-gateway.keypersafe.xyz',
  },
  '2345': {
    chainId: '2345',
    chainName: 'GOAT network',
    namespace: 'goat-network',
    cgwUrl: 'https://prod.goat-network-client-gateway.keypersafe.xyz',
  },
  '48816': {
    chainId: '48816',
    chainName: 'GOAT network testnet',
    namespace: 'goat-network',
    cgwUrl: 'https://prod.goat-network-client-gateway.keypersafe.xyz',
  },
  '47763': {
    chainId: '47763',
    chainName: 'Neo X',
    namespace: 'neox',
    cgwUrl: 'https://prod.neox-client-gateway.keypersafe.xyz',
  },
  '12227332': {
    chainId: '12227332',
    chainName: 'Neo X Testnet',
    namespace: 'neox',
    cgwUrl: 'https://prod.neox-client-gateway.keypersafe.xyz',
  },
  '295': {
    chainId: '295',
    chainName: 'hedera-mainnet',
    namespace: 'hedera-mainnet',
    cgwUrl: 'https://prod.hedera-mainnet-client-gateway.keypersafe.xyz',
  },
  '296': {
    chainId: '296',
    chainName: 'hedera-testnet',
    namespace: 'hedera-mainnet',
    cgwUrl: 'https://prod.hedera-mainnet-client-gateway.keypersafe.xyz',
  },
  '146': {
    chainId: '146',
    chainName: 'Sonic',
    namespace: 'sonic',
    cgwUrl: 'https://prod.sonic-client-gateway.keypersafe.xyz',
  },
  '1440000': {
    chainId: '1440000',
    chainName: 'xrpl-evm',
    namespace: 'xrpl-evm',
    cgwUrl: 'https://prod.xrpl-evm-client-gateway.keypersafe.xyz',
  },
  '1449000': {
    chainId: '1449000',
    chainName: 'xrpl-evm-testnet',
    namespace: 'xrpl-evm',
    cgwUrl: 'https://prod.xrpl-evm-client-gateway.keypersafe.xyz',
  },
  '1439': {
    chainId: '1439',
    chainName: 'Injective Testnet',
    namespace: 'injectiveevm-testnet',
    cgwUrl: 'https://prod.injectiveevm-testnet-client-gateway.keypersafe.xyz',
  },
  '9369': {
    chainId: '9369',
    chainName: 'Z Chain',
    namespace: 'z-chain',
    cgwUrl: 'https://prod.z-chain-client-gateway.keypersafe.xyz',
  },
  '1417429182': {
    chainId: '1417429182',
    chainName: 'zephyr',
    namespace: 'z-chain',
    cgwUrl: 'https://prod.z-chain-client-gateway.keypersafe.xyz',
  },
  '698': {
    chainId: '698',
    chainName: 'Matchain',
    namespace: 'matchain',
    cgwUrl: 'https://prod.matchain-client-gateway.keypersafe.xyz',
  },
  '1424': {
    chainId: '1424',
    chainName: 'Perennial',
    namespace: 'perennial',
    cgwUrl: 'https://prod.perennial-client-gateway.keypersafe.xyz',
  },
  '5031': {
    chainId: '5031',
    chainName: 'somnia Mainnet',
    namespace: 'somnia-mainnet',
    cgwUrl: 'https://prod.somnia-mainnet-client-gateway.keypersafe.xyz',
  },
  '50312': {
    chainId: '50312',
    chainName: 'Somnia Testnet',
    namespace: 'somnia-mainnet',
    cgwUrl: 'https://prod.somnia-mainnet-client-gateway.keypersafe.xyz',
  },
  '175188': {
    chainId: '175188',
    chainName: 'Chronicle Yellowstone | Lit',
    namespace: 'lit-chain',
    cgwUrl: 'https://prod.lit-chain-client-gateway.keypersafe.xyz',
  },
  '175200': {
    chainId: '175200',
    chainName: 'lit-chain',
    namespace: 'lit-chain',
    cgwUrl: 'https://prod.lit-chain-client-gateway.keypersafe.xyz',
  },
  '543210': {
    chainId: '543210',
    chainName: 'ZERѲ Network',
    namespace: 'zeronet-mainnet',
    cgwUrl: 'https://prod.wl-client-gateway.keypersafe.xyz',
  },
  '9069': {
    chainId: '9069',
    chainName: 'apex-fusion-nexus',
    namespace: 'aurora',
    cgwUrl: 'https://prod.safe-client-gateway.keypersafe.xyz',
  },
  '9070': {
    chainId: '9070',
    chainName: 'Apex Fusion Nexus Testnet',
    namespace: 'aurora',
    cgwUrl: 'https://prod.safe-client-gateway.keypersafe.xyz',
  },
  '1184075182': {
    chainId: '1184075182',
    chainName: 'sentient-testnet',
    namespace: 'aurora',
    cgwUrl: 'https://prod.safe-client-gateway.keypersafe.xyz',
  },
  '151': {
    chainId: '151',
    chainName: 'redbelly mainnet',
    namespace: 'redbelly-network',
    cgwUrl: 'https://prod.redbelly-network-client-gateway.keypersafe.xyz',
  },
  '153': {
    chainId: '153',
    chainName: 'redbelly testnet',
    namespace: 'redbelly-network',
    cgwUrl: 'https://prod.redbelly-network-client-gateway.keypersafe.xyz',
  },
  '3223': {
    chainId: '3223',
    chainName: 'XO Network',
    namespace: 'aurora',
    cgwUrl: 'https://prod.safe-client-gateway.keypersafe.xyz',
  },
  '278701': {
    chainId: '278701',
    chainName: 'Creator Testnet',
    namespace: 'aurora',
    cgwUrl: 'https://prod.safe-client-gateway.keypersafe.xyz',
  },
  '80069': {
    chainId: '80069',
    chainName: 'bepolia',
    namespace: 'bepolia',
    cgwUrl: 'https://prod.berachain-bepolia-client-gateway.keypersafe.xyz',
    scanApi: {
      url: 'https://api.etherscan.io/v2',
      apiKey: process.env.REACT_APP_ETHERSCAN_API_KEY || '',
    },
  },
  '3735928814': {
    chainId: '3735928814',
    chainName: 'Eden Celestia Testnet',
    namespace: 'eden',
    cgwUrl: 'https://prod.eden-client-gateway.keypersafe.xyz',
  },
  '714': {
    chainId: '714',
    chainName: 'Eden Celestia',
    namespace: 'eden',
    cgwUrl: 'https://prod.eden-client-gateway.keypersafe.xyz',
  },
}
